import React from 'react';
import { Languages, GraduationCap, BookOpen, CheckCircle } from 'lucide-react';
import { services } from '../data/mock';

const Services = () => {
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="bg-gradient-to-br from-amber-50 to-orange-50 py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">Hizmetlerimiz</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Çekya'da eğitim sürecinizin her aşamasında profesyonel danışmanlık ve destek sunuyoruz.
          </p>
        </div>
      </section>

      {/* Services Detail */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="space-y-16">
            {services.map((service, index) => {
              const IconComponent = {
                Languages,
                GraduationCap,
                BookOpen
              }[service.icon];
              
              return (
                <div
                  key={service.id}
                  className={`grid md:grid-cols-2 gap-12 items-center ${
                    index % 2 === 1 ? 'md:flex-row-reverse' : ''
                  }`}
                >
                  <div className={index % 2 === 1 ? 'md:order-2' : ''}>
                    <img
                      src={service.image}
                      alt={service.title}
                      className="rounded-2xl shadow-2xl w-full h-[400px] object-cover"
                    />
                  </div>
                  <div className={index % 2 === 1 ? 'md:order-1' : ''}>
                    <div className="w-16 h-16 bg-amber-100 rounded-xl flex items-center justify-center mb-6">
                      <IconComponent className="text-amber-600" size={32} />
                    </div>
                    <h2 className="text-4xl font-bold text-gray-900 mb-4">{service.title}</h2>
                    <p className="text-lg text-gray-600 mb-6">{service.description}</p>
                    <div className="space-y-3">
                      {service.features.map((feature, idx) => (
                        <div key={idx} className="flex items-center gap-3">
                          <CheckCircle className="text-green-500 flex-shrink-0" size={20} />
                          <span className="text-gray-700">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Ek Hizmetlerimiz</h2>
            <p className="text-xl text-gray-600">Size daha iyi hizmet verebilmek için sunduğumuz ek destekler</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Vize Danışmanlığı</h3>
              <p className="text-gray-600">Vize başvuru sürecinde tüm belgelerinizi hazırlıyor ve randevu alıyoruz.</p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Konaklama Desteği</h3>
              <p className="text-gray-600">Öğrenci yurdu veya daire seçenekleri için size en uygun seçeneği buluyoruz.</p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Havalimanı Karşılama</h3>
              <p className="text-gray-600">Prag'a vardığınızda sizi havalimanından alıp konaklamaya bırakıyoruz.</p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Tercüme Hizmetleri</h3>
              <p className="text-gray-600">Tüm belgelerinizin yeminli tercümesini yapıyoruz.</p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Banka Hesabı Açma</h3>
              <p className="text-gray-600">Çekya'da banka hesabı açma sürecinde size rehberlik ediyoruz.</p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <h3 className="text-xl font-bold text-gray-900 mb-3">24/7 Destek</h3>
              <p className="text-gray-600">Çekya'daki süreciniz boyunca her zaman ulaşabileceğiniz destek.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;